/**
 * Optional import source for AI training plan extraction (multipart field: importSource).
 * Add new competitors here + matching backend SOURCE_ADDENDUM.
 */
export const TRAINING_PLAN_IMPORT_SOURCE_STORAGE_KEY = "trainingPlansV2.importSource";

/** Default profile when nothing is stored or value is invalid — generic extraction prompt. */
export const DEFAULT_TRAINING_PLAN_IMPORT_SOURCE = "generic";

export const TRAINING_PLAN_IMPORT_SOURCES = [
  { id: "generic", label: "Auto (any format)", description: "Default extraction prompt." },
  {
    id: "everfit",
    label: "Everfit export",
    description: "Optimized for typical Everfit PDF/screenshot layouts.",
  },
];

/** @param {string} id */
export function isValidTrainingPlanImportSource(id) {
  return TRAINING_PLAN_IMPORT_SOURCES.some((s) => s.id === id);
}

/** Read persisted import format, or {@link DEFAULT_TRAINING_PLAN_IMPORT_SOURCE}. */
export function loadStoredTrainingPlanImportSource() {
  if (typeof window === "undefined") return DEFAULT_TRAINING_PLAN_IMPORT_SOURCE;
  try {
    const v = window.localStorage.getItem(TRAINING_PLAN_IMPORT_SOURCE_STORAGE_KEY);
    if (v && isValidTrainingPlanImportSource(v)) return v;
  } catch (_) {
    /* ignore */
  }
  return DEFAULT_TRAINING_PLAN_IMPORT_SOURCE;
}

/** @param {unknown} value */
export function normalizeTrainingPlanImportSource(value) {
  if (typeof value === "string" && isValidTrainingPlanImportSource(value)) return value;
  return DEFAULT_TRAINING_PLAN_IMPORT_SOURCE;
}
